// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__i3OA6","Loader__dark":"Loader_Loader__dark__iNekr","fadeInKeyframe":"Loader_fadeInKeyframe__hSuXJ"};